import React from 'react';
import TableHeaderSorter from '../widgets/sorts/TableHeaderSorter';
import { AdminDashboardTableHeaderRowInterface } from './interfaces';

const TableHeaderRow: React.FC<AdminDashboardTableHeaderRowInterface> = ({
  defaultRefinement,
  rowValues,
  allSelected,
  toggleAllSelected,
  numEmptyStartHeaders,
  numEmptyEndHeaders,
  numUnhiddenEmptyEndHeaders,
  allowBulkSelect,
}) => {
  return (
    <tr className="bg-table-header-gray">
      <th key="bulk" className="align-middle pr-1">
        {allowBulkSelect && (
          <input
            type="checkbox"
            checked={allSelected}
            onChange={() => toggleAllSelected && toggleAllSelected(!allSelected)}
          />
        )}
      </th>
      {!!(numEmptyStartHeaders && numEmptyStartHeaders > 0) && (
        <>
          {[...Array(numEmptyStartHeaders).keys()]
            .map((key) => {
              return (
                <th
                  key={`start-empty-header-${key}`}
                  className="start-empty-header d-xl-none"
                  aria-label="Empty header."
                />
              );
            })}
        </>
      )}
      <TableHeaderSorter
        defaultRefinement={defaultRefinement}
        items={rowValues}
      />
      {!!(numEmptyEndHeaders && numEmptyEndHeaders > 0) && (
        <>
          {[...Array(numEmptyEndHeaders).keys()]
            .map((key) => {
              return (
                <th
                  key={`end-empty-header-${key}`}
                  className="end-empty-header d-none d-xl-table-cell"
                  aria-label="Empty header."
                />
              );
            })}
        </>
      )}
      {!!(numUnhiddenEmptyEndHeaders && numUnhiddenEmptyEndHeaders > 0) && (
        <>
          {[...Array(numUnhiddenEmptyEndHeaders).keys()]
            .map((key) => {
              return (
                <th
                  key={`end-empty-header-unhidden-${key}`}
                  className="end-empty-header-unhidden d-xl-none"
                  aria-label="Empty header."
                />
              );
            })}
        </>
      )}
    </tr>
  );
};

TableHeaderRow.defaultProps = {
  numEmptyEndHeaders: 2,
  allowBulkSelect: true,
};

export default TableHeaderRow;
